<template>
  <slot v-if="!isLoading" />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useAuthStore } from '@/stores/auth';

const authStore = useAuthStore();

// Loading UI only: single source is auth store. Redirects and access control are handled by router.beforeEach.
const isLoading = computed(() => authStore.loading);
</script>

<!-- Styles supprimés car maintenant gérés par le composant AppLoading -->
